import LegalLayout from "@/components/LegalLayout";

export default function PrivacyPolicy() {
    return (
        <LegalLayout
            testId="privacy-policy-page"
            title="Privacy Policy"
            effectiveDate="02-02-2024"
        >
            <p>
                Thank you for choosing FilesCAD! This Privacy Policy is designed to help you understand how we collect, use, and safeguard your personal information when you use our mobile application and website. By using FilesCAD, you agree to the terms outlined in this Privacy Policy.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Information We Collect</h3>

            <h4 className="font-display font-bold text-lg text-slate-900 mt-6">Personal Information</h4>
            <ul className="list-decimal pl-6 space-y-1">
                <li>Full Name</li>
                <li>Mobile Number</li>
                <li>Email Address</li>
                <li>Company Name (if applicable)</li>
                <li>Machine Type</li>
            </ul>

            <h4 className="font-display font-bold text-lg text-slate-900 mt-6">Transaction and Payment Information</h4>
            <ul className="list-decimal pl-6 space-y-1">
                <li>Billing Information</li>
                <li>Payment Method Details</li>
            </ul>
            <p>We use Razorpay as our payment gateway partner.</p>

            <h4 className="font-display font-bold text-lg text-slate-900 mt-6">Usage Data</h4>
            <ul className="list-decimal pl-6 space-y-1">
                <li>Your liked designs</li>
                <li>Features used</li>
                <li>Date and time of your visits</li>
                <li>Error reports</li>
                <li>Download counts</li>
            </ul>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">How We Use Your Information</h3>
            <p>
                <strong>Providing Services:</strong> We use your personal information to provide, personalize, and improve our services. This includes delivering digital files, processing transactions, and enhancing user experience.
            </p>
            <p>
                <strong>Communication:</strong> We may use your contact information to send you important updates, newsletters, and promotional offers related to FilesCAD. You can opt-out of marketing communications at any time.
            </p>
            <p>
                <strong>Payment Processing:</strong> Your payment information is used solely for processing transactions securely. We do not store your payment details on our servers.
            </p>
            <p>
                <strong>Analytics:</strong> We analyze usage patterns to improve our services, troubleshoot issues, and enhance overall performance.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Information Sharing</h3>
            <p>
                We do not sell, trade, or otherwise transfer your personal information to third parties without your explicit consent, except for the purpose of providing our services.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Data Security</h3>
            <p>
                We implement industry-standard security measures to protect your personal information. However, no method of transmission over the internet or electronic storage is completely secure. Therefore, we cannot guarantee absolute security.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Your Choices</h3>
            <p>
                You can update your account information and preferences at any time. You may also request the deletion of your account, subject to legal and contractual restrictions.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Third-Party Services</h3>
            <p>
                FilesCAD may contain links to third-party websites or services. We are not responsible for the privacy practices or content of these third-party sites.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Changes to the Privacy Policy</h3>
            <p>
                We may update this Privacy Policy to reflect changes in our practices. Any material changes will be communicated to you through the app or website.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Children&rsquo;s Privacy</h3>
            <p>
                This Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Contact Us</h3>
            <p>
                If you have any questions or concerns about our Privacy Policy, please contact us at:{" "}
                <a
                    href="mailto:support@filescad.com"
                    data-testid="privacy-contact-email"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
            </p>

            <p className="mt-8 italic text-slate-500">
                By using FilesCAD, you acknowledge that you have read and understood this Privacy Policy.
            </p>
        </LegalLayout>
    );
}
